import { render, staticRenderFns } from "./UbicationView.vue?vue&type=template&id=5e0dae3d&scoped=true"
import script from "./UbicationView.vue?vue&type=script&lang=js"
export * from "./UbicationView.vue?vue&type=script&lang=js"
import style0 from "./UbicationView.vue?vue&type=style&index=0&id=5e0dae3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0dae3d",
  null
  
)

export default component.exports